export const selectUserId = (state) => state.auth.userId;
export const selectAuth = (state) => state.auth;
export const selectAccessToFunnel = (state) => state.auth.hasAccessToFunnel;
